import { Record } from 'immutable';
import PropTypes from 'prop-types';
import immutablePropTypes from 'react-immutable-proptypes';

class ActionDTO extends Record({
  description: null,
  id: null,
  imageUrl: null,
  link: null,
  title: null,
  type: null
}) {
  constructor(dataObject) {
    const {
      fields: {
        description,
        image: {
          fields: {
            file: { url }
          }
        },
        link,
        title,
        type
      },
      sys: { id }
    } = dataObject;

    super({
      description,
      id,
      imageUrl: url,
      link,
      title,
      type
    });
  }
}

const ActionPropTypes = immutablePropTypes.recordOf({
  description: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['charity', 'leftWing', 'rightWing'])
});

export { ActionDTO, ActionPropTypes };



// WEBPACK FOOTER //
// ./src/services/dto/action.js